module.exports = __webpack_public_path__ + "img/start0_teo.8559b685.jpg";